import styles from './FundingSidebar.module.scss';

const FundingSidebar = ({ sections, onSectionClick }) => {
  return (
    <aside className={styles.sidebar}>
      <nav className={styles['sidebar-nav']}>
        <ul>
          {sections.map((section) => (
            <li key={section.id}>
              <button
                type="button"
                className={styles['sidebar-item']}
                onClick={() => onSectionClick(section.id)}
              >
                {section.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default FundingSidebar;